<!--&================== TITLE TASK ==================&-->
<div class="title-components">
  <h1>Tarea asignada</h1>
</div>

<!--&================= CONTENT-TASKS =================&-->

<div class="Content-Task-Alone">
  <div class="Body-Card-Task">
    <div class="Body-Card-Alone">
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Nombre de Tarea
        </div>
        <div class="Text-Information">
          {{Task_CCP.Name}}
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Fecha de asignación
        </div>
        <div class="Text-Information">
          {{GetDate_Assigned(Task_CCP.Date_Start)}}
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Asignada por
        </div>
        <div class="Text-Information">
          {{Task_CCP.NameUser}}
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Descripción
        </div>
        <div class="Text-Information">
          Se le ha asignado la tarea de revisión del documento: {{Task_CCP.Name}}
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Ubicación en librería
        </div>
        <div (click)="SeeCCPLibrary()" class="Text-Information Btn-Ubication btn-icon-text-left">
          <span class="text">Ubicación HOE</span><i class="fa-solid fa-location-arrow"></i>
        </div>
      </div>
      <div class="Content-Grid-Task2">
        <div class="Text-Task">
          Descargar
        </div>
        <div class="Container-Button">
          <button (click)="PreviewFile($event)" class="Btn-Download-Global" style="background: #20a8e1; color: white; display: flex; align-items: center; justify-content: center; border: none; border-radius: var(--border-buton-r0);">
            <div class="Content-Download">
              <span class="Btn-Text">Vista Previa</span>
              <i class="fa-regular fa-eye" style="margin-left: 5px;"></i>
            </div>
          </button>

          <button (click)="DownloadFile()" class="Text-Information Btn-Download-Local Btn-Download-Global"
            id="Btn-Download">
            <div class="Content-Download">
              <span class="Progress-Bar-Task" id="Progress-Bar-Task"></span>
              <span class="Btn-Text" id="Text-Btn">Descargar HOE</span>
              <i class="fa-solid fa-cloud-arrow-down" id="Icon-Btn"></i>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!---================= CONTENT-BTNS =================--->
    <div class="Bottom-Card-Alone">
      <div class="Container-Btn-Alone">
        <div class="Btn-Approved">
          <div (click)="ApproveCCP()" class="btn-icon-text-left">
            <span class="text">Aprobar</span><i class="fa-solid fa-check-double"></i>
          </div>
        </div>
        <div (click)="ToggleModalReasonReject(true)" class="Btn-Reject">
          <div class="btn-icon-text-left">
            <span class="text">Rechazar</span><i class="fa-solid fa-xmark"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR REASON FOR REJECTION =====================--->
<section class="Modal-Global" id="ModalReject">
  <div class="wrapper">
    <div class="Pro-popup1 popup">
      <div class="Pro-inside1 popup-inside">
        <div class="Pro-backgrounds1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormReject" (ngSubmit)="SaveReject()">
        <div class="Pro-content1 content">
          <div (click)="ToggleModalReasonReject(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2>Rechazar HOE</h2>
            <h4>Escribe la razón de rechazo de la HOE</h4>
          </div>

          <div class="Content-body">
            <div class="Content-grid-1">
              <div class="Container-input Text-Area-Form">
                <i class="fa-solid fa-signature"></i><textarea id="IdTextAreaRejectCCP" formControlName="ReasonText"
                  placeholder="Razón de rechazo ..."></textarea>
              </div>
            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form1 btn-icon-text">
              <i class="fa-solid fa-location-arrow"></i><span class="text">Enviar</span>
            </button>
            <div (click)="ToggleModalReasonReject(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<app-document-viewer [visible]="showPreview" [fileName]="previewFileName" [fileUrl]="previewFileUrl"
  [extension]="previewFileExtension" (onClose)="showPreview = false" (onDownload)="DownloadFromPreview()">
</app-document-viewer>
